import { currentYear, currentMonth, RELEASE_NOTES_CDN_URL } from 'src/config';
import { ReleaseNote } from 'src/components/WhatsNew/WhatsNew';
import { MONTHS_IN_PAST } from 'src/components/WhatsNew/FeatureForm/FeatureForm';
import moment from 'moment';
import { logger } from 'src/utils/logger';

const fetchMonthData = async (
	year: number,
	month: number
): Promise<ReleaseNote | null> => {
	const formattedMonth = month.toString().padStart(2, '0');

	try {
		const response = await fetch(
			`${RELEASE_NOTES_CDN_URL}/releases/version.${year}.${formattedMonth}.json`
		);

		if (!response.ok) return null;

		const releaseNotes = await response.json();

		if (!releaseNotes.version || !Array.isArray(releaseNotes.features)) {
			logger.warn(
				`Invalid release notes format [ year : month ] ::: [ ${year} : ${formattedMonth} ]`
			);

			return null;
		}

		releaseNotes.features.forEach(
			(f: { type: string }) =>
				(f.type = f.type.toLowerCase().replace(/_/g, '-'))
		);

		return releaseNotes;
	} catch {
		// Expected when release notes don't exist for a given month
		return null;
	}
};

export const fetchReleaseNotesIncremental = (
	onUpdate: (notes: ReleaseNote[], currentVersion: string) => void,
	onComplete?: () => void
): Promise<void> => {
	const results: (ReleaseNote | null)[] = new Array(MONTHS_IN_PAST).fill(null);

	const emitUpdate = () => {
		const notes = results.filter((n): n is ReleaseNote => n !== null);

		onUpdate(notes, notes[0]?.version ?? '');
	};

	const promises = Array.from({ length: MONTHS_IN_PAST }, (_, i) => {
		const date = moment()
			.year(Number(currentYear))
			.month(currentMonth - 1)
			.subtract(i, 'months');

		return fetchMonthData(date.year(), date.month() + 1).then((note) => {
			results[i] = note;
			emitUpdate();
		});
	});

	return Promise.all(promises).then(() => {
		onComplete?.();
	});
};
